import placementModule  from './placer.js';

export default {
    __init__ : [ 'placementModule' ],
    placementModule : [ 'type', placementModule]
};